
import { namespace, Mutation, Getter } from "vuex-class";
import { Component, Vue, Mixins, Prop, Watch } from "vue-property-decorator";
import { formatDateMixin } from "@/mixins";
import vSelect from "vue-select";
import { Datetime } from "vue-datetime";
import { retry } from "rxjs/operators";

const Reports = namespace("reports");
const { relativeDaysDateFormatted } = formatDateMixin.methods;

import EventOutcomeSelector from "@/components/EventOutcomeSelector.vue";

@Component({
	components: {
		"v-select": vSelect,
		"event-outcome-selector": EventOutcomeSelector,
		datetime: Datetime
	}
})
export default class ReportFilters extends Vue {
	@Reports.Getter("getReport") report;
	@Reports.Getter("getRelativeDaysToReport") relativeDaysToReport;

	@Reports.Action loadDatePref: () => Promise<void>;

	@Reports.State ReportDateFormatPref: boolean;


	async created() {
		this.TimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		await this.loadDatePref();
	}

	@Prop()
	public value: any;

	public selectedFilters: any;

	public mounted () {
		if (this.value)
			this.selectedFilters = this.value;
	}

	@Watch("value")
	valueChanged(value) {
		this.selectedFilters = value;
	}

	private TimeZone = "UTC";
	private getReportRelativeDays() {
		return this.relativeDaysToReport;
	}

	private outcomeChanged(value) {
		if (value) {
			this.value.eventOutcomeId.splice(0, 9, { id: value });
		} else {
			this.value.eventOutcomeId = [];
		}
	}

	public get dateTimePickerFormat() {
		return this.ReportDateFormatPref ? "dd LLL yyyy HH:mm" : "dd/MM/yyyy HH:mm"
	}
}
